import React from "react";

const ZoneDetailsContainer = ({ room, temperature, energy }) => {
  return (
    <div
      style={{
        padding: "0px 15px",
        display: "flex",
        flexDirection: "column",
        color: "white",
      }}
    >
      <div>Zone {room}</div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Temperature : </span>
        <span>{temperature} °C</span>
      </div>
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Energy</span>
        <span>{energy}</span>
      </div> */}
    </div>
  );
};

export default ZoneDetailsContainer;
